import { render, staticRenderFns } from "./HealthcareService.vue?vue&type=template&id=61fb4132&scoped=true"
import script from "./HealthcareService.vue?vue&type=script&lang=js"
export * from "./HealthcareService.vue?vue&type=script&lang=js"
import style0 from "./HealthcareService.vue?vue&type=style&index=0&id=61fb4132&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fb4132",
  null
  
)

export default component.exports